import api from '@/utils/api'

export default {
    async save(filter) {
        return api.post(`user-filter-presets`, filter)
    },
    async delete(presetId) {
        return api.delete(`user-filter-presets/${presetId}`)
    }
}
